import { RefString } from "@tblabs/truffle";
import { Field } from "./Field";
import { FieldType } from "./FieldType";
import { RawMarkdownField } from "./RawMarkdownField";


export class MarkdownField extends Field
{
    public Type = FieldType.Markdown;

    public Markdown = new RefString();

    constructor(raw: Partial<RawMarkdownField>)
    {
        super(raw);

        this.Markdown.value = raw.Markdown || "";
    }
}
